import { getFieldValue, isTrackingPage } from 'selectors';
import { DEFAULT_LOCALE, SET_LOCALE } from '../../constants';
import { I18n, normalizeLocale } from '../../utils/translations';

export const setLocale =
  locale =>
  async (dispatch, getState, { userLanguage }) => {
    const state = getState();
    const normalizedLocale = normalizeLocale(locale);
    const isValid = I18n.isValid(normalizedLocale);
    const validatedLocale = isValid ? normalizedLocale : DEFAULT_LOCALE;

    const senderEmail = getFieldValue(state, 'sender_email');
    if (isTrackingPage(state)) {
      userLanguage.update(senderEmail, locale);
    }

    dispatch({
      type: SET_LOCALE,
      payload: { locale: validatedLocale },
    });
  };
